import { useEffect, useState } from 'react';
import Modal from 'react-responsive-modal';
import metaDataServices from '../MetaDataServices';
import Pagination from 'components/Common/newPagination';


export default function ExistingSong(param: any) {

    let [searchSongCount, setsearchSongCount] = useState(0);
    let [searchSongList, setsearchSongList] = useState<any>([]);
    let [songSearch, setSongSearch] = useState<any>([]);
    var payLoad = {
        pageNumber: 1,
        pageSize: 10
    }
    const closeExistingSong = () => {
        param.closeSongListing();
    }

    useEffect(() => {
        apicall();
    }, [param.SongListingOpen])


    const apicall = () => {
        metaDataServices.publishingSongList(payLoad).then((res:any) => {
            searchSongCount = res[0].totalRows;
            setsearchSongCount(searchSongCount)
            searchSongList = res
            setsearchSongList(searchSongList);
        })

    }
    const songSelection = (e: any) => {
        param.closeSongListing(e)
    }

    const onPageChange = (e: any) => {
        payLoad.pageNumber = e.pageNumber
        payLoad.pageSize = e.pageSize
        apicall();
        console.log(e)
    }

    const resetFilter = () => {

    }

    const searchFilter = () => {

    }

    const NewSong = () => {

    }

    return (<>
        <Modal open={param.SongListingOpen} onClose={() => closeExistingSong()} center>

            <div className="ws-12 landing ">

                <div className="box-header  noBorderRadius bg-blue pLarge">Song Management</div>
                <div className='pm ws-12'>

                    <div className='ws-12 box pm'>

                        <div className="ws-4 pm">
                            <label className="ws-12 text-bold" htmlFor="songRef">Song Ref</label>
                            <div className="label-entries">
                                <input className="ws-12" id="songRef" name="songRef" type="text" placeholder="Song Ref" value={songSearch.songRef} />
                            </div>
                        </div>

                        <div className="ws-4 pm">
                            <label className="ws-12 text-bold" htmlFor="iSWC">ISWC</label>
                            <div className="label-entries">
                                <input className="ws-12" id="iSWC" name="iSWC" type="text" placeholder="ISWC" value={songSearch.iSWC} />
                            </div>
                        </div>

                        <div className="ws-4 pm">
                            <label className="ws-12 text-bold" htmlFor="songTitle">Song Title</label>
                            <div className="label-entries">
                                <input className="ws-12" id="songTitle" name="songTitle" type="text" placeholder="Song Title" value={songSearch.songTitle} />
                            </div>
                        </div>

                        <div className="ws-4 pm">
                            <label className="ws-12 text-bold" htmlFor="songPublisher">Song Publisher</label>
                            <div className="label-entries">
                                <input className="ws-12" id="songPublisher" name="songPublisher" type="text" placeholder="Song Publisher" value={songSearch.songPublisher} />
                            </div>
                        </div>

                        <div className="ws-4 pm">
                            <label className="ws-12 text-bold" htmlFor="songCollector">Song Collector</label>
                            <div className="label-entries">
                                <input className="ws-12" id="songCollector" name="songCollector" type="text" placeholder="Song Collector" value={songSearch.songCollector} />
                            </div>
                        </div>

                        <div className="ws-4 pm">
                            <label className="ws-12 text-bold" htmlFor="productionName">Production Name</label>
                            <div className="label-entries">
                                <input className="ws-12" id="productionName" name="productionName" type="text" placeholder="Production Name" value={songSearch.productionName} />
                            </div>
                        </div>

                        <div className="ws-12 pm">
                            <button type="button" className="icon-btn icon-btn-save pull-left" onClick={() => NewSong()}>New Song</button>
                            <button type="button" className="icon-btn edit pull-right" onClick={() => searchFilter()}>🔍 Search</button>
                            <button type="button" className="icon-btn delete pull-right" onClick={() => resetFilter()}>↻ Reset</button>
                        </div>
                    </div>

                    <div className='ws-12 mtl'>
                        <div className="box-header well">
                            <h2> List of songs{" "}  {searchSongList && searchSongList.length > 0 && (<span>({searchSongList[0].totalRows})</span>)}  </h2>
                        </div>

                        <div className="box-content box">
                            <div className="row-fluid">
                                {(!searchSongList || searchSongList.length === 0) && (
                                    <div className="alert alert-info">No songs to display</div>
                                )}

                                {searchSongList && searchSongList.length > 0 && (
                                    <table className="newTable ">
                                        <thead>
                                            <tr>
                                                <th>Song Ref</th>
                                                <th>ISWC</th>
                                                <th>Song Title</th>
                                                <th>Song Main Composer</th>
                                                <th>Song Main Publisher</th>
                                                <th>% Split</th>
                                                <th style={{ width: "8%" }}>Operation</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {searchSongList.map((searchSongItem: any) => (
                                                <tr key={searchSongItem.songID}>
                                                    <td>{searchSongItem.songRef}</td>
                                                    <td>{searchSongItem.intStdWorkCode}</td>

                                                    <td>
                                                        <span title={searchSongItem.songName}>
                                                            {searchSongItem.songName?.slice(0, 40)}
                                                            {searchSongItem.songName?.length > 40 && "..."}
                                                        </span>
                                                    </td>

                                                    <td>
                                                        <span title={searchSongItem.songMainComposer}>
                                                            {searchSongItem.songMainComposer?.slice(0, 40)}
                                                            {searchSongItem.songMainComposer?.length > 40 && "..."}
                                                        </span>
                                                    </td>

                                                    <td>
                                                        <span title={searchSongItem.songMainPublisher}>
                                                            {searchSongItem.songMainPublisher?.slice(0, 40)}
                                                            {searchSongItem.songMainPublisher?.length > 40 && "..."}
                                                        </span>
                                                    </td>

                                                    <td className="text-right">{searchSongItem.publishingSplit}</td>

                                                    <td>
                                                        <button className="icon-btn info" onClick={() => songSelection(searchSongItem)}>Select  </button>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                )}

                                <div className="clearfix">

                                    {
                                        (() => {
                                            if (searchSongCount && searchSongCount > 10) {
                                                return <Pagination onPageChange={onPageChange} totalRow={searchSongCount} />
                                            }
                                        })()
                                    }

                                </div>
                            </div>
                        </div>

                    </div>

                </div>

            </div>
        </Modal>
    </>)
}